/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

// Angular
import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { Http, Headers, RequestOptions } from '@angular/http';

// Ngrx
import { Store } from '@ngrx/store';

// Rxjs
import { Observable } from "rxjs/Observable";
import '@api/rxjs-operators';

// Celine
import { RouterService } from '@api/services/router.service';
import { ExperienceService } from '../services/experience.service';

import { User } from '@api/models/user';

import { PageNotFoundComponent } from '@api/components/page-not-found.component';
import { SearchResultsListComponent } from './../components/search/search-results-list.component';
import { SessionExpiredComponent } from '../components/session-expired/session-expired.component';
import { UserProfileSwitchRedirectComponent } from '../components/user/user-profile-switch-redirect.component';
// import { HomeComponent, UnauthorizedComponent } from '@threshold/components/index';
import { Widget } from '@api/models';
import { ModuleLoaderService } from "@api/index";
import * as apiUI from '@api/store/actions/ui.actions';
import * as thresholdActions from '../store/actions/actions';
import { LoadExperienceAction } from '../store/actions/experience.actions';

import { NoAccessComponent } from '../components/no-access/no-access.component';
import { NoWidgetComponent } from '../components/no-widget/no-widget.component';
import { NotificationsComponent } from '../components/notifications/notifications.component';
import { DownloadMobileAppComponent } from '../components/mobile/download-mobile-app.component';
import { Experience } from '../models/experience';
import { ManageMFADeviceComponent } from './../components/manage-mfa-device/manage-mfa-device-component';
import { WidgetFrameComponent } from '../../celine/components/widget-frame/widget-frame.component';


/**
 * Service to get and manage the routes for Connected Experience
 */
@Injectable()
export class RouterConnectedService extends RouterService {
    static initialRoutes(): Route[] {
        return [
            {
                path: 'search/:searchPhrase',
                component: SearchResultsListComponent
            },
            {
                path: 'session-expired',
                component: SessionExpiredComponent
            },
            {
                path: 'profile-switch/:userProfileId',
                component: UserProfileSwitchRedirectComponent
            },
            {
                path: 'notifications',
                component: NotificationsComponent
            },
            {
                path: 'widget-frame',
                component: WidgetFrameComponent
            },
            {
                path: 'manage-mfa-device',
                component: ManageMFADeviceComponent
            },
            {
                path: 'download-mobile-app',
                component: DownloadMobileAppComponent
            },
            ...RouterService.initialRoutes()
        ];
    }

    constructor (protected experienceService: ExperienceService, protected http: Http, protected router: Router, protected moduleLoaderService: ModuleLoaderService, protected store: Store<any>) {
        super(experienceService, http, router, moduleLoaderService, store);
    }

    /**
     *
     */
    createAuthorizationHeader(headers: Headers) {
        let token = sessionStorage.getItem('authorizationData');
        headers.set('Authorization', `Bearer ${token}`);
    }

    /**
     *
     */
    getDashboard(): Observable<any> {
        let authToken = sessionStorage.getItem('authorizationData');
        let headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        return this.http.get('/api/dashboard', {
            headers: headers
        })
    }

    /**
     *
     */
    getMenu(): Observable<any> {
        let authToken = sessionStorage.getItem('authorizationData');
        let headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);
        return this.http.get('/api/experience', {
            headers: headers
        })
    }

    /**
     * Return routes from backend and transform them into array of Route
     * @return Observable array of Routes
     */
    getRoutes(): Observable<Route[]> {

        let hasWidgets: boolean = false;

        return this.getMenu()
            .map(response => response.json())
            .map(experiences => ({
                "experiences": experiences
            }))
            .do((response: any) => {

                window['__CELINE_exp'] = response.experiences;
                this.experienceService.setInitialState(response.experiences);

                let widgets: Widget[] = [];
                response.experiences.map((experience: any) => {
                    const nextVersion = (experience && experience.tags && experience.tags['celineVersion']) ? true : false;
                    if (experience.widgets instanceof Array) {
                        for (let i = 0; i < experience.widgets.length; i++) {
                            hasWidgets = true;

                            let url: string = '';
                            let moduleName: string = '';
                            if (experience.moduleUrl) {
                                url = experience.moduleUrl.split('#')[0]
                                moduleName = experience.moduleUrl.split('#')[1]
                            }

                            experience.widgets[i].connectedExperience = experience.name;


                            //-----------------------------------
                            // What type of Widget is this?
                            //-----------------------------------
                            // --> Smart = Dynamically created @components
                            if ((!nextVersion) && experience.widgets[i].componentId) {
                                experience.widgets[i].type = 'smart';
                                experience.widgets[i].moduleUrl = `${url}#Widget${moduleName}` // WidgetModule
                            }

                            if ((nextVersion) && experience.widgets[i].componentId) {

                                if (!process.env.config.feature.versionNext.frameWidget) {
                                    break;
                                }

                                experience.widgets[i].type = 'iframe';
                                experience.widgets[i].ce = experience.name;
                            }

                            // --> Static = Celine static @component
                            if (!experience.widgets[i].componentId) {
                                experience.widgets[i].type = 'static';
                                experience.widgets[i].moduleUrl = experience.moduleUrl;

                                // defaults
                                if (!experience.widgets[i].title) experience.widgets[i].title = experience.name;
                                if (!experience.widgets[i].bannerImage) experience.widgets[i].bannerImage = 'absa_generic.jpg';
                                if (!experience.widgets[i].supportingText) experience.widgets[i].supportingText = experience.description;
                                if ((!experience.widgets[i].externalLink) && !experience.widgets[i].routerLink) experience.widgets[i].routerLink = experience.path;
                                if (!experience.widgets[i].buttonLabel) experience.widgets[i].buttonLabel = 'Launch';
                                if (nextVersion) {
                                    if (experience.tags['celineVersion'] === '2') {
                                        experience.widgets[i].onClickLink = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v2/#/' + experience.widgets[i].routerLink; experience.widgets[i].routerLink = '';
                                    }

                                    if (experience.tags['celineVersion'] === '3') {
                                        experience.widgets[i].onClickLink = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v3/#/' + experience.widgets[i].routerLink; experience.widgets[i].routerLink = '';
                                    }
                                }
                            }

                            widgets.push(experience.widgets[i]);
                        }
                    }
                })

                this.store.dispatch(new apiUI.LoadDashboardSuccessAction(widgets)),
                    this.store.dispatch(new LoadExperienceAction(response.experiences))
            })
            .map(response => this.thresholdTranslateRoutes(response, hasWidgets))
    }

    /**
     * Threshold translate routes
     * @param routes
     */
    private thresholdTranslateRoutes(routes: any, anyWidgets?: boolean): Route[] {
        let result: Route[] = [];

        // user has no application/s -> add NoAccessComponent as default route
        if (routes.experiences.length === 0) result.push(<Route>{ path: '', component: NoAccessComponent });

        // user has applications/s but no widgets
        if ((routes.experiences.length >= 1) && (!anyWidgets)) result.push(<Route>{ path: '', component: NoWidgetComponent });

        // user has application/s and widgets -> add DashboardComponent as default route
        if ((routes.experiences.length >= 1) && (anyWidgets)) {
            result.push(this.generateLoadChildrenRoute('', '', true));
            // add application routes to celine
            routes.experiences.map(data => data).map((experience, i) => { result.push(this.generateLoadChildrenRoute(experience.path, experience.moduleUrl, false)); })
        }

        return result;
    }

    private translateRoutes(menu: any): Route[] {
        let result: Route[] = [];
        result.push(...menu.dashboards.map((menuItem: any) => this.generateLoadChildrenRoute(menuItem.routerPath, menuItem.dashboardUrl, true)));
        result.push(...menu.portlets.map((menuItem: any) => this.generateLoadChildrenRoute(menuItem.routerPath, menuItem.moduleUrl, false)));
        return result;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/router-threshold.service.ts